import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import components from '../components'
import vuex from './vuex'
import vueRouter from './vueRouter'
import * as element from './element'
import * as utils from './utils'
import * as math from './math'

import http from './http'
import consts from '../consts'

// 全局对象
export default function (app, config = {}) {
  components(app)

  const mm = {
    ...element,
    ...vuex,
    ...vueRouter,
    utils,
    math,

    // 初始化
    init() {
      this.store = useStore()
      this.router = useRouter()
      this.route = useRoute()

      this.consts = consts()
      this.http = http
    },
    // 历史记录
    history() {
      mm.store.commit('HISTORY_PUSH')
    }
  }

  // template 中使用
  app.config.globalProperties.mm = mm
  app.config.globalProperties.document = document
  app.config.globalProperties.window = window

  // setup_hooks.sh 中使用
  globalThis.mm = mm

  return mm
}
